/**
 * User product import state class
 */
class UserProductImportLogEntry {
    /**
     * Id of the log entry
     */
    public id: number;

    /**
     * User mail that was affected
     */
    public userMail: string;

    /**
     * Product number
     */
    public productNumber: string;

    /**
     * true if an error occured while importing the user
     */
    public errorOccured: boolean;

    /**
     * Error message
     */
    public errorMessage: string;

    /**
     * Time the log was created
     */
    public createTime: Date;
    
    /**
     * Constructor
     * @param id Id of the entry
     * @param userMail Mail of the user to import
     * @param productNumber Product number
     * @param errorOccured true if an error occured while importing the user
     * @param errorMessage Error message
     */
    public constructor(id: number, userMail: string, productNumber: string, errorOccured: boolean, errorMessage: string)
    {
        this.id = id;
        this.userMail = userMail;
        this.productNumber = productNumber;
        this.errorOccured = errorOccured;
        this.errorMessage = errorMessage;
        this.createTime = new Date();
    }
}

export default UserProductImportLogEntry;